/**
 * Установка PWA и инструкции доступны только по нажатию кнопки.
 */
export default function initPwaInstall() {
    const containers = [...document.querySelectorAll('[data-pwa-install-container]')];
    const buttons = containers.map(container => container.querySelector('[data-pwa-install]'));
    const displayMode = window.matchMedia('(display-mode: standalone)');
    let installed = displayMode.matches || navigator.standalone === true;
    let installPrompt = null;
    let installing = false;

    const updateButtons = () => {
        containers.forEach(container => {
            container.hidden = installed;
        });
        buttons.forEach(button => {
            button.disabled = installing;
        });
    };

    const showHelp = (container, message) => {
        const help = container.querySelector('[data-pwa-install-help]');
        help.textContent = message;
        help.hidden = false;
    };

    const beforeInstall = event => {
        event.preventDefault();
        if (!installed) {
            installPrompt = event;
        }
    };

    const appInstalled = () => {
        installed = true;
        installPrompt = null;
        updateButtons();
    };

    const displayModeChanged = event => {
        if (event.matches) {
            appInstalled();
        }
    };

    const install = async event => {
        if (installed || installing) {
            return;
        }

        const container = event.currentTarget.closest('[data-pwa-install-container]');
        if (!installPrompt) {
            const isAppleMobile = /iPad|iPhone|iPod/.test(navigator.userAgent)
                || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
            showHelp(container, isAppleMobile
                ? 'Открой сайт в Safari, нажми «Поделиться», затем «На экран Домой».'
                : 'Открой меню браузера и выбери «Установить приложение» или «Добавить на главный экран». Если такого пункта нет, попробуй открыть сайт в Chrome или Edge.');
            return;
        }

        const prompt = installPrompt;
        installPrompt = null;
        installing = true;
        containers.forEach(item => {
            item.querySelector('[data-pwa-install-help]').hidden = true;
        });
        updateButtons();

        try {
            const choice = await prompt.prompt();
            if (choice.outcome === 'accepted') {
                appInstalled();
            }
        } catch {
            showHelp(container, 'Не удалось открыть установку. Попробуй установить приложение через меню браузера.');
        } finally {
            installing = false;
            updateButtons();
        }
    };

    window.addEventListener('beforeinstallprompt', beforeInstall);
    window.addEventListener('appinstalled', appInstalled);
    displayMode.addEventListener('change', displayModeChanged);
    buttons.forEach(button => button.addEventListener('click', install));
    updateButtons();

    return () => {
        window.removeEventListener('beforeinstallprompt', beforeInstall);
        window.removeEventListener('appinstalled', appInstalled);
        displayMode.removeEventListener('change', displayModeChanged);
        buttons.forEach(button => button.removeEventListener('click', install));
    };
}
